"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsperaSdk = exports.ActivityTracking = exports.ActivityMessage = exports.TransferResponse = exports.AsperaSdkInfo = void 0;
var constants_1 = require("../constants/constants");
var messages_1 = require("../constants/messages");
var safari_client_1 = require("../helpers/client/safari-client");
var helpers_1 = require("../helpers/helpers");
var ws_1 = require("../helpers/ws");
var index_1 = require("../index");
var AsperaSdkGlobals = /** @class */ (function () {
    function AsperaSdkGlobals() {
        /** The URL of the IBM Aspera HTTP server to use with the SDK */
        this.asperaAppUrl = 'http://127.0.0.1';
        /** The URL of the IBM Aspera Desktop HTTP server to use with the SDK */
        this.rpcPort = 33024;
        /** The default URL to check for latest Aspera installers */
        this.installerUrl = constants_1.installerUrl;
        /** Indication that the server has been verified as working */
        this.asperaAppVerified = false;
        /** Map of drop zones created by querySelector */
        this.dropZonesCreated = new Map();
    }
    AsperaSdkGlobals.prototype.backupLaunchMethod = function (url) {
        window.alert(messages_1.messages.loadingProtocol);
        window.location.href = url;
    };
    /**
     * Launch the IBM Aspera App via protocol url. By default, a hidden IFRAME attempts to
     * open the app but if that fails a fallback of opening a new window happens.
     */
    AsperaSdkGlobals.prototype.launch = function () {
        var _this = this;
        try {
            var element = document.createElement('iframe');
            element.src = constants_1.protocol;
            element.onerror = function (error) {
                (0, helpers_1.errorLog)(messages_1.messages.failedToGenerateIframe, error);
                _this.backupLaunchMethod(constants_1.protocol);
            };
            element.setAttribute('style', constants_1.hiddenStyleList);
            document.body.appendChild(element);
        }
        catch (error) {
            (0, helpers_1.errorLog)(messages_1.messages.failedToGenerateIframe, error);
            this.backupLaunchMethod(constants_1.protocol);
        }
    };
    return AsperaSdkGlobals;
}());
var AsperaSdkInfo = /** @class */ (function () {
    function AsperaSdkInfo() {
    }
    return AsperaSdkInfo;
}());
exports.AsperaSdkInfo = AsperaSdkInfo;
var TransferResponse = /** @class */ (function () {
    function TransferResponse() {
    }
    return TransferResponse;
}());
exports.TransferResponse = TransferResponse;
var ActivityMessage = /** @class */ (function () {
    function ActivityMessage() {
    }
    return ActivityMessage;
}());
exports.ActivityMessage = ActivityMessage;
var ActivityTracking = /** @class */ (function () {
    function ActivityTracking() {
        /** Map of callbacks that receive transfer update events */
        this.activity_callbacks = new Map();
        /** Map of callbacks that received removed transfer events */
        this.removed_callbacks = new Map();
        /** Map of callbacks that receive connection events */
        this.event_callbacks = new Map();
        /** Map of callbacks that receive Safari extension events */
        this.safari_extension_callbacks = new Map();
        /** Keep track of the last WebSocket event **/
        this.lastWebSocketEvent = 'CLOSED';
        /** Keep track of the last Safari extension event **/
        this.lastSafariExtensionEvent = 'DISABLED';
    }
    /**
     * Notify all consumers when a message is received from the websocket
     *
     * @param message the message received from the websocket
     */
    ActivityTracking.prototype.handleTransferActivity = function (message) {
        if (message.type === 'transferUpdated') {
            this.activity_callbacks.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback(message.data);
                }
            });
        }
        if (message.type === 'transferRemoved') {
            this.removed_callbacks.forEach(function (callback) {
                if (typeof callback === 'function') {
                    callback(message.data);
                }
            });
        }
    };
    /**
     * Notify all consumers when a connection webSocketEvent occurs. For example, when the SDK
     * websocket connection to IBM Aspera App is closed or reconnected.
     *
     * @param webSocketEvent the event type.
     */
    ActivityTracking.prototype.handleWebSocketEvents = function (webSocketEvent) {
        if (this.lastWebSocketEvent === webSocketEvent) {
            return;
        }
        this.event_callbacks.forEach(function (callback) {
            if (typeof callback === 'function') {
                callback(webSocketEvent);
            }
        });
        this.lastWebSocketEvent = webSocketEvent;
    };
    /**
     * Notify all consumers when a Safari extension safariExtensionEvent occurs (enabled/disabled).
     *
     * @param safariExtensionEvent the event type.
     */
    ActivityTracking.prototype.handleSafariExtensionEvents = function (safariExtensionEvent) {
        if (this.lastSafariExtensionEvent === safariExtensionEvent) {
            return;
        }
        this.safari_extension_callbacks.forEach(function (callback) {
            if (typeof callback === 'function') {
                callback(safariExtensionEvent);
            }
        });
        this.lastSafariExtensionEvent = safariExtensionEvent;
    };
    /**
     * Set up the activity tracking with IBM Aspera.
     *
     * @returns a promise that resolves when the websocket connection is established.
     * Currently, this promise does not reject.
     */
    ActivityTracking.prototype.setup = function () {
        var _this = this;
        if (index_1.asperaSdk.globals.sessionId) {
            this.registerDesktopAppSession();
        }
        if ((0, helpers_1.isSafari)()) {
            return safari_client_1.safariClient.monitorTransferActivity();
        }
        return ws_1.websocketService.init()
            .then(function () {
            ws_1.websocketService.registerMessage('transfer_activity', function (data) { return _this.handleTransferActivity(data); });
            ws_1.websocketService.registerEvent(function (status) { return _this.handleWebSocketEvents(status); });
        });
    };
    /**
     * Register a callback for getting transfers back to the consumer
     *
     * @param callback the function to call with the array of transfers
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setCallback = function (callback) {
        if (typeof callback !== 'function') {
            (0, helpers_1.errorLog)(messages_1.messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.activity_callbacks.size + 1);
        this.activity_callbacks.set(id, callback);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeCallback = function (id) {
        this.activity_callbacks.delete(id);
    };
    /**
     * Register a callback for getting transfers back to the consumer
     *
     * @param callback the function to call with the array of transfers
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setRemovedCallback = function (callback) {
        if (typeof callback !== 'function') {
            (0, helpers_1.errorLog)(messages_1.messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.removed_callbacks.size + 1);
        this.removed_callbacks.set(id, callback);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeRemovedCallback = function (id) {
        this.removed_callbacks.delete(id);
    };
    /**
     * Register a callback for getting websocket events back to the consumer
     *
     * @param callback the function to call with the websocket event
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setWebSocketEventCallback = function (callback) {
        if (typeof callback !== 'function') {
            (0, helpers_1.errorLog)(messages_1.messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.event_callbacks.size + 1);
        this.event_callbacks.set(id, callback);
        callback(this.lastWebSocketEvent);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeWebSocketEventCallback = function (id) {
        this.event_callbacks.delete(id);
    };
    /**
     * Register a callback for getting Safari extension events back to the consumer
     *
     * @param callback the function to call with the websocket event
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setSafariExtensionEventCallback = function (callback) {
        if (typeof callback !== 'function') {
            (0, helpers_1.errorLog)(messages_1.messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.safari_extension_callbacks.size + 1);
        this.safari_extension_callbacks.set(id, callback);
        callback(this.lastSafariExtensionEvent);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeSafariExtensionEventCallback = function (id) {
        this.safari_extension_callbacks.delete(id);
    };
    ActivityTracking.prototype.registerDesktopAppSession = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = "aspera://initialize?app_id=".concat(index_1.asperaSdk.globals.appId, "&session_id=").concat(index_1.asperaSdk.globals.sessionId);
        document.body.appendChild(iframe);
        setTimeout(function () {
            document.body.removeChild(iframe);
        }, 1000);
    };
    return ActivityTracking;
}());
exports.ActivityTracking = ActivityTracking;
var AsperaSdk = /** @class */ (function () {
    function AsperaSdk() {
        /** Global information about IBM Aspera */
        this.globals = new AsperaSdkGlobals();
        /** Activity tracking for watching transfers */
        this.activityTracking = new ActivityTracking();
    }
    Object.defineProperty(AsperaSdk.prototype, "isReady", {
        /**
         * Check if IBM Aspera is ready to be used and has been verified.
         *
         * @returns a boolean indicating if SDK can be used for requests
         */
        get: function () {
            return this.globals.asperaAppVerified && this.globals.appId !== '';
        },
        enumerable: false,
        configurable: true
    });
    return AsperaSdk;
}());
exports.AsperaSdk = AsperaSdk;
